import React from "react";

import Icon from "shared/components/Icon";

import { BannerContainer, BannerContent, BannerMessage } from "./styled";

export interface ViewOnlyBannerProps {
  message?: string;
}

const ViewOnlyBanner: React.FC<ViewOnlyBannerProps> = ({ 
  message = "These settings are view-only and managed by VERO. Contact your Customer Success Manager if changes are needed."
}) => {
  return (
    <BannerContainer>
      <BannerContent>
        <Icon.InfoBannerBlueWarning />
        <BannerMessage>{message}</BannerMessage>
      </BannerContent>
    </BannerContainer>
  );
};

export default ViewOnlyBanner;

